<template>
    <div v-if="admin.is_admin">
        <button-secondary @click="open">
            <template slot="icon"><i class="fa fa-pencil"></i></template> Usergruppen verwalten
        </button-secondary>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">
                    <span v-show="page === 'overview'">Usergruppen verwalten</span>
                    <a @click="page='overview'" v-show="page === 'create'">
                        <i class="fa fa-chevron-left mr-2"></i> Usergruppe erstellen
                    </a>
                    <a @click="page='overview'" v-show="page === 'edit'">
                        <i class="fa fa-chevron-left mr-2"></i> Usergruppe bearbeiten
                    </a>
                </template>
                <div v-show="page === 'overview'">
                    <loading v-show="loading"></loading>

                    <div v-show="!loading">
                        <tailwind-table class="mb-4" :header="['Name', 'User', '']">
                            <tr v-for="(group,i) in userGroups" :class="{'bg-gray-50': i%2}">
                                <td class="px-6 py-2">
                                    <span v-show="group.is_default" class="font-bold">
                                        {{ group.name }} (default)
                                    </span>
                                    <span v-show="!group.is_default">
                                        {{ group.name }}
                                    </span>
                                    <br>
                                    <span v-show="!group.is_default" class="italic text-gray-500">
                                        {{ group.name_internal }}
                                    </span>
                                    <span v-show="group.is_internal" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                                        Nur Intern
                                    </span>
                                </td>
                                <td class="px-6 py-2">{{ group.users_count }}</td>
                                <td class="px-2 py-2 text-right mr-2">
                                    <button-white @click="selectGroup(group.id)">
                                        Bearbeiten
                                    </button-white>
                                </td>
                            </tr>
                        </tailwind-table>

                        <div class="flex justify-end">
                            <button-primary @click="page = 'create'">
                                <template slot="icon"><i class="fa fa-plus"></i></template> Usergruppe hinzufügen
                            </button-primary>
                        </div>
                    </div>

                </div>
                <div v-if="page === 'create'">
                    <user-group-create @created="created"></user-group-create>
                </div>
                <div v-if="page === 'edit'">
                    <user-group-edit :id="selectedGroup" @updated="created"></user-group-edit>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonPrimary from "./UI/ButtonPrimary";
import Modal from "./Modal";
import UserGroupCreate from "./UserGroupCreate";
import UserGroupEdit from "./UserGroupEdit";
import ButtonWhite from "./UI/ButtonWhite";
import Loading from "./UI/Loading";
import TailwindTable from "./UI/TailwindTable";
import ButtonSecondary from "./UI/ButtonSecondary";

export default {
    name: "UserGroups",
    components: {
        ButtonSecondary,
        TailwindTable, Loading, ButtonWhite, UserGroupEdit, UserGroupCreate, Modal, ButtonPrimary,
    },

    inject: ['admin'],

    data: () => ({
        page: 'overview',
        showModal: false,
        loading: false,
        userGroups: [],
        selectedGroup: null,    
    }),

    methods: {
        open() {
            this.showModal = true;
            this.page = 'overview';
            this.load();
        },
        selectGroup(id) {
            this.selectedGroup = id;
            this.page = 'edit';
        },
        load() {
            this.loading = true;
            window.axios.get('/admin/user_groups').then(result => {
                this.loading = false;
                this.userGroups = result.data.data;
                this.$emit('data', 'userGroups')
            })
        },
        created() {
            this.load();
            this.page = 'overview';
        }
    }
}
</script>

<style scoped>

</style>
